import React from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'components/Select';
import { Text, Flex } from '@qga/roo-ui/lib/components';
import { themeGet } from 'styled-system';
import { SORT_SELECT_OPTIONS } from 'lib/enums/search';
import { getQuerySortBy } from 'store/router/routerSelectors';
import { sortSelect, updateQuery, sortOpen } from 'store/search/searchActions';

const StyledSelect = styled(Select)`
  border-radius: ${themeGet('radii.default')};
  border: ${themeGet('borders.2')} ${themeGet('colors.greys.alto')};
  background-color: ${themeGet('colors.white')};
  cursor: pointer;
  ::-ms-expand {
    display: none;
  }

  &:focus {
    box-shadow: 0 0 0 1pt ${themeGet('colors.ui.linkFocus')};
  }
`;

const SortSelect = React.memo(() => {
  const sortBy = useSelector(getQuerySortBy);
  const dispatch = useDispatch();

  const onChange = ({ target: { value } }) => {
    const { label } = SORT_SELECT_OPTIONS.find((option) => option.value === value);
    dispatch(updateQuery({ sortBy: value }));
    dispatch(
      sortSelect({
        sortField: label,
        sortOrder: value,
      }),
    );
  };

  const onFocus = () => {
    dispatch(sortOpen());
  };

  return (
    <Flex flexDirection="column" mb={8}>
      <Text color="greys.charcoal" fontSize="18px">
        Sort by:
      </Text>

      <StyledSelect
        value={sortBy}
        options={SORT_SELECT_OPTIONS}
        onChange={onChange}
        onFocus={onFocus}
        aria-label="Sort search results"
        data-testid="sort-select"
      />
    </Flex>
  );
});

SortSelect.displayName = 'SortSelect';

export default SortSelect;
